// BEGIN: Simple modal
export function simpleModal() {
    jQuery('.simple-modal-trigger').on('click', function(e) {
        e.preventDefault();

        var $this = jQuery(this);
        var target = $this.attr('data-target');

        var $modal = jQuery('#' + target);
        $modal.toggleClass('show-modal');

        if ($modal.hasClass('show-modal')) {
            jQuery('body').css('overflow', 'hidden');
        } else {
            jQuery('body').css('overflow', 'auto');
        }
    });

    jQuery('.modal-content .close-button').on('click', function(e) {
        e.preventDefault();

        jQuery(this).closest('.show-modal').removeClass('show-modal');
        jQuery('body').css('overflow', 'auto');
    });
}